module.exports = __webpack_public_path__ + "media/images/icon/arrow-down-f1e1036dc0594c8a339e086ce7081c46.svg";